// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__18KjE","title":"AfterImages90_title__27i3a","images":"AfterImages90_images__D3-OJ"};